/** WebSocket connection with automatic reconnect. */
import type { ClientMessage, ServerMessage } from '../shared/protocol.ts';

export type ConnectionStatus = 'connecting' | 'open' | 'closed';

export class Connection {
  private ws: WebSocket | null = null;
  private retry = 0;
  private stopped = false;
  private readonly url: string;
  onMessage: (msg: ServerMessage) => void = () => {};
  onStatus: (status: ConnectionStatus) => void = () => {};
  onOpen: () => void = () => {};

  constructor(room: string) {
    const proto = location.protocol === 'https:' ? 'wss' : 'ws';
    this.url = `${proto}://${location.host}/ws?room=${encodeURIComponent(room)}`;
  }

  connect(): void {
    this.onStatus('connecting');
    const ws = new WebSocket(this.url);
    this.ws = ws;
    ws.onopen = () => {
      this.retry = 0;
      this.onStatus('open');
      this.onOpen();
    };
    ws.onmessage = (e) => this.onMessage(JSON.parse(String(e.data)) as ServerMessage);
    ws.onclose = () => {
      if (this.stopped) return;
      this.onStatus('closed');
      const delay = Math.min(5000, 500 * 2 ** this.retry++);
      setTimeout(() => this.connect(), delay);
    };
  }

  /** Stops for good (the party removed this player): no more reconnecting. */
  stop(): void {
    this.stopped = true;
    this.ws?.close();
  }

  send(msg: ClientMessage): void {
    if (this.ws?.readyState === WebSocket.OPEN) this.ws.send(JSON.stringify(msg));
  }
}
